export default __webpack_public_path__ + "static/media/logoempresa.f22bfe6c.png";